// Clearoute Starter — main JS entry.
//
// SPEC §6.2. Imports SCSS first (webpack compiles as a side-effect), then
// Bootstrap (no jQuery), then theme components.

import '../scss/main.scss';
import '../scss/editor-styles.scss';

// Bootstrap 5 — no jQuery dependency. Attaches to data-bs-* attributes.
import * as bootstrap from 'bootstrap';

// Expose globally so per-block JS that loads after main.js can reach it
// without bundling its own copy.
window.bootstrap = bootstrap;

// ──────────────────────────────────────────────────────────────────────────
// Theme components — pure-function imports, called explicitly from here.
// ──────────────────────────────────────────────────────────────────────────

// Example component slot — populate as the theme grows.
// import { initNavToggle }  from './components/nav';
// import { initLightbox }   from './components/lightbox';

// ──────────────────────────────────────────────────────────────────────────
// Side-effect modules — auto-init on import. SPEC §6.1.
// ──────────────────────────────────────────────────────────────────────────

// import './modules/image-lazy-load.js';
// import './modules/scroll-animations.js';

// ──────────────────────────────────────────────────────────────────────────
// Bootstrap
// ──────────────────────────────────────────────────────────────────────────

document.addEventListener('DOMContentLoaded', () => {
  // initNavToggle();
  // initLightbox();
});
